export const saveTokenToLocalStorage = (token: number | string): void => {
  const data = JSON.stringify({
    value: token,
    expiry: Date.now() + (Number(localStorage.getItem('tokenExpiration')) || 60 * 60 * 48) * 1e3,
  })
  localStorage.setItem('token', data)
}
